// buildParams.js
/**
 * Dynamically builds API request parameters.
 * - Accepts any number of dynamic key-value pairs
 * - Automatically filters out null/undefined values
 * - Keeps code centralized and reusable
 */

export const buildAPIRequestParams = (params = {}) => {
  const validParams = {};

  // remove empty or undefined keys automatically
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      validParams[key] = value;
    }
  });

  return validParams;
};
